import { axiosClient } from '../../../library/Service/axiosClient';
import { EntrepreneurAnalysisData, GetDashboardResponse, UploadResponse } from './types';

const BASE = `${process.env.REACT_APP_ADMIN_API_SERVER}/institute`;

class ProfileAnalyticsService {
    /** Fetch the stored dashboard JSON for an institute. data === null => empty state. */
    static async getDashboard(instituteId: string | number): Promise<GetDashboardResponse> {
        const res = await axiosClient().get(`${BASE}/${instituteId}/profile-analytics`);
        return res.data as GetDashboardResponse;
    }

    /** Fetch the hourly DB snapshot dashboard (management / institute-admin view). */
    static async getSnapshotDashboard(instituteId: string | number): Promise<GetDashboardResponse> {
        const res = await axiosClient().get(
            `${process.env.REACT_APP_REPORTS_SERVER}/profile-analytics/${instituteId}`
        );
        return res.data as GetDashboardResponse;
    }

    /** Upload (or re-upload) an institute's analytics .xlsx. */
    static async uploadFile(instituteId: string | number, file: File): Promise<UploadResponse> {
        const form = new FormData();
        form.append('file', file);
        // Do NOT set Content-Type manually — the browser must add the multipart
        // boundary, otherwise multer cannot parse the upload.
        const res = await axiosClient().post(`${BASE}/${instituteId}/profile-analytics/upload`, form);
        return res.data as UploadResponse;
    }

    /** URL for downloading the original uploaded file (auth header still required). */
    static downloadUrl(instituteId: string | number): string {
        return `${BASE}/${instituteId}/profile-analytics/download`;
    }

    /** Live Entrepreneur Alumni Analysis — same predicates as Entrepreneur Directory. */
    static async getEntrepreneurAnalysis(schoolId: Array<string | number>): Promise<EntrepreneurAnalysisData | null> {
        const res = await axiosClient().post(
            `${process.env.REACT_APP_REPORTS_SERVER}/entrepreneur-directory/analysis`,
            { schoolId, level: 'MY_SCHOOL' }
        );
        return res.data?.data ?? null;
    }
}

export default ProfileAnalyticsService;
